import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { useDialogDefaultProps } from '../utils';
import { DialogContentStyle } from './styles';
import { RcDialogContentClasses } from './utils';
var _RcDialogContent = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcDialogContent' });
    var classesProp = props.classes, children = props.children, size = props.size, rest = __rest(props, ["classes", "children", "size"]);
    var classes = useMemo(function () { return combineClasses(RcDialogContentClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiDialogContent, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcDialogContent = styled(_RcDialogContent).attrs(useDialogDefaultProps)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), DialogContentStyle);
RcDialogContent.defaultProps = {};
RcDialogContent.displayName = 'RcDialogContent';
export { RcDialogContent };
var templateObject_1;
